var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVotedForFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7548 6.59996V3.39998C10.7548 2.76347 10.4979 2.15302 10.0405 1.70294C9.58316 1.25285 8.96287 1 8.31609 1L5.06449 8.19995V16.9999H14.234C14.6261 17.0043 15.0066 16.869 15.3053 16.6191C15.6041 16.3692 15.801 16.0214 15.8598 15.6399L16.9816 8.43995C17.017 8.21064 17.0012 7.9765 16.9355 7.75376C16.8698 7.53102 16.7557 7.325 16.601 7.14997C16.4464 6.97495 16.2549 6.83511 16.0399 6.74014C15.8249 6.64517 15.5915 6.59734 15.3558 6.59996H10.7548ZM5.06449 16.9999H2.6258C2.19461 16.9999 1.78108 16.8313 1.47618 16.5313C1.17129 16.2312 1 15.8243 1 15.3999V9.79994C1 9.3756 1.17129 8.96864 1.47618 8.66858C1.78108 8.36852 2.19461 8.19995 2.6258 8.19995H5.06449",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06449 8.19995L8.31609 1C8.96287 1 9.58316 1.25285 10.0405 1.70294C10.4979 2.15302 10.7548 2.76347 10.7548 3.39998V6.59996H15.3558C15.5915 6.59734 15.8249 6.64517 16.0399 6.74014C16.2549 6.83511 16.4464 6.97495 16.601 7.14997C16.7557 7.325 16.8698 7.53102 16.9355 7.75376C17.0012 7.9765 17.017 8.21064 16.9816 8.43995L15.8598 15.6399C15.801 16.0214 15.6041 16.3692 15.3053 16.6191C15.0066 16.869 14.6261 17.0043 14.234 16.9999H5.06449M5.06449 8.19995V16.9999M5.06449 8.19995H2.6258C2.19461 8.19995 1.78108 8.36852 1.47618 8.66858C1.17129 8.96864 1 9.3756 1 9.79994V15.3999C1 15.8243 1.17129 16.2312 1.47618 16.5313C1.78108 16.8313 2.19461 16.9999 2.6258 16.9999H5.06449",
    stroke: "#4CAF50",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotedForFilled);
export default __webpack_public_path__ + "static/media/VotedForFilled.788ddb082ebfce311046749acff785dc.svg";
export { ForwardRef as ReactComponent };